import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./menu.module.scss";
import ItemComponent from "./item.component";

export default function MenuPage({ close, setItem }) {
  const api = process.env.REACT_APP_API;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const closeMenu = () => {
    setItem(undefined);
    close();
  };

  useEffect(() => {
    const categories = localStorage.getItem("categories");
    if (categories) {
      setCategories(JSON.parse(categories));
    }

    let products = localStorage.getItem("products");
    if (products) {
      products = JSON.parse(products);
      setProducts(
        products
          .sort((a, b) => {
            return a.position - b.position;
          })
          .map((d) => {
            return {
              ...d,
              qty: 0,
            };
          })
      );
    }
  }, []);

  return (
    <div className={styles.menu}>
      {categories
        .filter((list) => list.parent === undefined)
        .map((category, index) => {
          return (
            <React.Fragment key={category._id}>
              <div className={styles.header}>{category.name}</div>
              <div className={styles.productGrid}>
                {products.map((product) => {
                  if (
                    product.category &&
                    product.category.filter((list) => list._id === category._id)
                      .length > 0
                  ) {
                    return (
                      <div
                        className={styles.item}
                        onClick={() => setItem(product)}
                        key={product._id}
                      >
                        {product.name}
                      </div>
                    );
                  }
                })}
              </div>
            </React.Fragment>
          );
        })}

      <div className={styles.floatingButtons} onClick={close}>
        Salirse
      </div>
    </div>
  );
}
